function checkout()
{
    jQuery(function ($) {
        // Show/hide message to inform the user that the shipping address is the same as the billing address.
        $('#ship-to-different-address-checkbox').prop('checked') ? $('.shipping_address_same_as_billing').hide() : $('.shipping_address_same_as_billing').show();

        $('#ship-to-different-address-checkbox').on('change', function() {
            $(this).prop('checked') ? $('.shipping_address_same_as_billing').hide() : $('.shipping_address_same_as_billing').show();
        })

        // Trick for Colissimo map not sizing properly on display.
        // There is a weird bug with the Colissimo map for pickup relays where the
        // map is not properly sized when added to the DOM. As soon as a resize event
        // is fired the canvas is correctly resized, but when added to the dom it's
        // not. This trick here watch for the map being added to the dom and fires a
        // resize event so that the script that handles the map resize can set a new
        // size to the canvas, and thus the map is displayed on the right size.
        var observer = new MutationObserver(function (mutationsList, observer) {
            for (var i = 0; i < mutationsList.length; ++i) {
                var mutation = mutationsList[i];

                if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length > 0) {
                    for (var j = 0; j < mutation.addedNodes.length; j++) {
                        var n = mutation.addedNodes[j];

                        if ($(n).hasClass('cdiselectlocation')) {
                            window.dispatchEvent(new Event('resize'));
                            return;
                        }
                    }
                }
            }
        });
        observer.observe(document.body, { attributes: true, childList: true, subtree: true });

        // If inputs are not filled, toggle them.
        // if ($('#billing_first_name').val() == ''
        //     || $('#billing_last_name').val() == ''
        //     || $('#billing_country').val() == ''
        //     || $('#billing_address_1').val() == ''
        //     || $('#billing_postcode').val() == ''
        //     || $('#billing_city').val() == ''
        //     || $('#billing_phone').val() == ''
        //     || $('#billing_email').val() == ''
        // ) {
        //     $('.billing_address').removeClass('completed');
        //     $('#billing_address_save').show();
        // }
        // else {
        //     $('#billing_address_update').show();
        // }

        // if ($('#shipping_first_name').val() == ''
        //     || $('#shipping_last_name').val() == ''
        //     || $('#shipping_country').val() == ''
        //     || $('#shipping_address_1').val() == ''
        //     || $('#shipping_city').val() == ''
        //     || $('#shipping_postcode').val() == ''
        // ) {
        //     $('.shipping_address').removeClass('completed');
        //     $('#shipping_address_save').show();
        // } else {
        //     $('#shipping_address_update').show();
        // }

        // Toggle use different shipping addres
        // $('#ship-to-different-address').on('click', function (e) {
        //     e.preventDefault();
        //     $('#ship-to-different-address-checkbox').prop('checked', !($('#ship-to-different-address-checkbox').attr('checked') === 'checked'));

        //     var checked = $('#ship-to-different-address-checkbox').attr('checked') === 'checked';

        //     if (checked) {
        //         $('.shipping_address').removeClass('completed');
        //         $('#shipping_address_save').show();
        //         $('#shipping_address_update').hide();
        //     } else {
        //         $('.shipping_address').addClass('completed');
        //         $('#shipping_address_save').hide();
        //         $('#shipping_address_update').show();
        //     }
        // })

        // Show form to edit.
        // $('#billing_address_save').on('click', function () {
        //     if ($('#shipping_first_name').val() != ''
        //         && $('#shipping_last_name').val() != ''
        //         && $('#shipping_country').val() != ''
        //         && $('#shipping_address_1').val() != ''
        //         && $('#shipping_city').val() != ''
        //         && $('#shipping_postcode').val() != ''
        //     ) {
        //         $('.billing_address').addClass('completed');
        //         $('#billing_address_update').show();
        //         $(this).hide();
        //     }
        // });
        // $('#billing_address_update').on('click', function () {
        //     $('.billing_address').removeClass('completed');
        //     $('#billing_address_save').show();
        //     $(this).hide();
        // });
        // $('#shipping_address_save').on('click', function() {
        //     if ($('#billing_first_name').val() != ''
        //         && $('#billing_last_name').val() != ''
        //         && $('#billing_country').val() != ''
        //         && $('#billing_address_1').val() != ''
        //         && $('#billing_postcode').val() != ''
        //         && $('#billing_city').val() != ''
        //         && $('#billing_phone').val() != ''
        //         && $('#billing_email').val() != ''
        //     ) {
        //         $('.shipping_address').addClass('completed');
        //         $('#shipping_address_update').show();
        //         $(this).hide();
        //     }
        // });
        // $('#shipping_address_update').on('click', function () {
        //     $('.shipping_address').removeClass('completed');
        //     $('#shipping_address_save').show();
        //     $(this).hide();
        // });

        $('#billing_phone').on('blur', function() {
            var wrapper = $(this).closest('.form-row');

            if (/^(\+336|\+3306|06|07)[0-9]{8}$/.test($(this).val())) {
                wrapper.addClass('woocommerce-validated');
            } else {
                wrapper.addClass('woocommerce-invalid');
            }
        })
    });
}

export { checkout };
